var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    id: "chat",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(5 -1031.362)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 1044.362,
    r: 13,
    fill: "#1d67b1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#154082",
    d: "M13.498 25.982a13 13 0 0 0 .422-.015 13 13 0 0 0 1.289-.156 13 13 0 0 0 1.268-.286 13 13 0 0 0 1.234-.408 13 13 0 0 0 1.185-.531 13 13 0 0 0 1.127-.647 13 13 0 0 0 1.057-.755 13 13 0 0 0 .977-.858 13 13 0 0 0 .886-.951 13 13 0 0 0 .786-1.035 13 13 0 0 0 .68-1.108 13 13 0 0 0 .566-1.17 13 13 0 0 0 .445-1.22 13 13 0 0 0 .32-1.26 13 13 0 0 0 .196-1.285A13 13 0 0 0 26 13a13 13 0 0 0-.033-.92 13 13 0 0 0-.088-.72L21 6.48a.524.477 0 0 0-.525-.478H5.525V6A.524.477 0 0 0 5 6.479c-.002 3.354-.004 7.21.025 10.996a.524.477 0 0 0 .471.47l2.496 2.496v.036a.524.477 0 0 0 .47.47l5.036 5.035z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal",
      marker: "none"
    },
    transform: "translate(-5 1031.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.76 1015.225a.491.491 0 0 0-.492.493c-.002 3.454-.004 7.425.024 11.322a.491.491 0 0 0 .494.49l2.284-.015v2.617a.491.491 0 0 0 .826.356l3.126-2.959H85.758a.491.491 0 0 0 .468-.49c0-3.681.024-7.634.024-11.319a.491.491 0 0 0-.492-.493H71.76zm.492.984h13.014c-.002 3.383-.018 6.953-.02 10.339h-7.42a.491.491 0 0 0-.338.135l-2.438 2.308v-1.967a.491.491 0 0 0-.494-.492l-2.284.014c-.023-3.56-.022-7.143-.02-10.337zm2.761 2.083v1.03h8.426v-1.03h-8.426zm0 2.058v1.03h8.426v-1.03h-8.426zm3.746 2.059v1.03h4.68v-1.03h-4.68z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal",
      marker: "none"
    },
    transform: "matrix(1.06795 0 0 .97117 -76.11 51.402)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.e63a0e9057c1da3425fe6017ca3a8619.svg";
export { ForwardRef as ReactComponent };